import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
const deliverables = [{
  title: 'The Complete 40-Page Digital Manual',
  description: "The core 'Cortisol Switch' system explaining exactly how to master your stress hormones."
}, {
  title: 'The 7-Minute Pre-Sleep Protocol',
  description: 'Step-by-step physical routine to signal safety to your brain before bed.'
}, {
  title: 'The 4-7-8 Vagal Brake Technique',
  description: 'A specific breathing ratio for instant anxiety relief when you feel overwhelmed.'
}, {
  title: "The 'Anti-Spike' Nighttime Grocery List",
  description: 'The exact foods that actually lower stress and stabilize your system.'
}, {
  title: "The 14-Day 'Switch' Meal Planner",
  description: 'Done-for-you nutrition to stabilize blood sugar and prevent 3 AM wake-ups.'
}, {
  title: "The 'Morning Momentum' Strategy",
  description: 'A strategic caffeine protocol to end the 2 PM crash forever.'
}];
export function WhatYouGet() {
  return <section className="py-10 bg-slate-800" data-id="element-655">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-656">
        <ScrollFadeIn data-id="element-657">
          <div className="text-center mb-16" data-id="element-658">
            <h2 className="text-3xl md:text-4xl font-serif text-slate-50 mb-4" data-id="element-659">
              What You Get Inside
            </h2>
            <p className="text-lg text-slate-400" data-id="element-660">
              Everything you need to flip the switch tonight.
            </p>
          </div>
        </ScrollFadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-661">
          {deliverables.map((item, index) => <ScrollFadeIn key={index} delay={index * 0.1} data-id="element-662">
              <div className="bg-slate-900 border border-slate-700 p-8 rounded-2xl h-full flex flex-col" data-id="element-663">
                <CheckCircle2 className="w-8 h-8 text-emerald-400 mb-6" data-id="element-664" />
                <h3 className="text-xl font-medium text-slate-50 mb-3" data-id="element-665">
                  {item.title}
                </h3>
                <p className="text-slate-400 leading-relaxed flex-grow" data-id="element-666">
                  {item.description}
                </p>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}